const userfilterSortReducer = (
    state = {},
    action: {
      type: "SET_USER_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_USER_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  export default userfilterSortReducer;